import axios from 'axios';

// Configure axios
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Laravel Echo Configuration
 *
 * Echo + Pusher (~110KB) are dynamically imported only when VITE_REVERB_APP_KEY
 * is set. In production (Vapor), this key is blank so these modules are
 * tree-shaken from the main bundle entirely.
 *
 * @see https://laravel.com/docs/broadcasting
 * @see https://laravel.com/docs/reverb
 */
if (import.meta.env.VITE_REVERB_APP_KEY) {
  import('./echo').catch((error) => {
    console.warn('[Echo] Failed to load Echo module:', error);
  });
} else {
  console.log('[Echo] No REVERB_APP_KEY found, Echo disabled');
}
